export const channelNames = {
   WHATSAPP: 'WhatsApp',
   TELEGRAM: 'Telegram',
   MAX: 'Max'
}

export const channelTypes = {
   WHATSAPP: 'whatsapp',
   TELEGRAM: 'telegram',
   MAX: 'max'
}